(function () {
  'use strict';

  angular.module('sempraWebapp').factory('ReadingTypeEnum', readingTypeEnumFactory);

  /** @ngInject */
  function readingTypeEnumFactory () {
    return Object.freeze({
      FLAG: 'FLAG',
      RANGE: 'RANGE',
      COUNTER: 'COUNTER',
      T: 'T',
      HEXTIME: 'HEXTIME',
      TIME: 'TIME',
      TEMPERATURE: 'TEMPERATURE',
      properties: {
        'FLAG': {
          parse: function (value) {
            return parseInt(value, 10) === 1;
          }
        },
        'STRING': {
          parse: function (value) {
            return value;
          }
        },
        'RANGE': {
          parse: function (value) {
            return value;
          }
        },
        'COUNTER': {
          parse: function (value) {
            return value;
          }
        },
        'T': {
          parse: function (value) {
            return parseFloat(value);
          }
        },
        'HEXTIME': {
          parse: function (value) {
            return value;
          }
        },
        'TIME': {
          parse: function (value) {
            return value;
          }
        },
        'TEMPERATURE' : {
          parse: function (value) {
            return value;
          }
        }
      }
    });
  }
})();
